import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { Prompt, RouteComponentProps, StaticContext } from 'react-router';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { scrollToErrorElement } from 'src/utils/helpers';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { getBackStepPath } from '~/helpers';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import PromoBannerActionPanel from '../../components/PromoBannerActionPanel/PromoBannerActionPanel';
import { promobannerStore } from '../../store/promobannerStore';
import PromoBannerCreateContent from './components/PromobannerCreateContent/PromoBannerCreateContent';
import './style.scss';
import { history } from '~/services/history';

type TProps = RouteComponentProps<{ id: string }, StaticContext, undefined>;

const PromoBannerCreate = observer((props: TProps) => {
  const backStepPath = useRef(getBackStepPath(SCREENS.PROMOBANNERS())).current;

  useEffect(() => {
    promobannerStore.validator();
    return promobannerStore.unMount;
  }, []);

  const handleClose = () => {
    history.push(SCREENS.PROMOBANNERS());
  };

  const handleSave = async () => {
    if (!promobannerStore.isValid.all) {
      scrollToErrorElement();
      return;
    }

    const response = await promobannerStore.createPromobanner();
    if (response) handleClose();
  };

  return (
    <div className="d-flex flex-1 flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('create_promo_banner')} path={backStepPath} />
      </Headers>

      <ScrollableBlock showScrollbar className="d-flex flex-1 mr-1" scrollClassName="pb-2">
        <PromoBannerCreateContent />
      </ScrollableBlock>

      <PromoBannerActionPanel onSave={handleSave} />

      <LoadingOverlay visible={promobannerStore.loading} />
      <Prompt when={promobannerStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default PromoBannerCreate;
